import { defineComponent, ref, computed } from "vue";
import useDeviceManager from "../../../hooks/useDeviceManager.mjs";
import SvgIcon from "../../common/base/SvgIcon.vue.mjs";
import SpeakerPhoneIcon from "../../common/icons/SpeakerPhoneIcon.vue.mjs";
import EarpieceIcon from "../../common/icons/EarpieceIcon.vue.mjs";
import { TUIAudioRoute } from "@tencentcloud/tuiroom-engine-js";
import "../../../directives/vTap.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "SwitchAudioRoute",
  setup(__props) {
    const { deviceManager } = useDeviceManager();
    const currentAudioRoute = ref(
      TUIAudioRoute.kAudioRouteSpeakerphone
    );
    const icon = computed(
      () => currentAudioRoute.value === TUIAudioRoute.kAudioRouteSpeakerphone ? SpeakerPhoneIcon : EarpieceIcon
    );
    async function handleSwitchAudioRoute() {
      var _a;
      const audioRoute = currentAudioRoute.value === TUIAudioRoute.kAudioRouteSpeakerphone ? TUIAudioRoute.kAudioRouteEarpiece : TUIAudioRoute.kAudioRouteSpeakerphone;
      await ((_a = deviceManager.instance) == null ? void 0 : _a.setAudioRoute({
        route: audioRoute
      }));
      currentAudioRoute.value = audioRoute;
    }
    return { __sfc: true, deviceManager, currentAudioRoute, icon, handleSwitchAudioRoute, SvgIcon };
  }
});
export {
  _sfc_main as default
};
